(function () {
    'use strict';

    angular.module('swif.ui')
    .directive('swifHeadTitle', swifHeadTitle);

    /**
     * @ngdoc directive
     * @name swif.ui:swifHeadTitle
     * @module swif.ui
     * @restrict A
     * @description sync the title of the page with the content (from settings.page)
    **/
    function swifHeadTitle(settingsService) {
        'ngInject';
        return {
            restrict: 'A',
            scope: {},
            template: '{{page.title || app.title || "OpenGST" | translate }}',
            link: function (scope, element) {
                scope.page = settingsService.page;
                scope.app = settingsService.app;
            }
        };
    }

})();
